import { GRID_UNIT } from './constants';

export function grid(units: number): number {
  return units * GRID_UNIT;
}
